<template>
  <div>
    <!--banner-->
    <div class="w100 cpfa">
      <div class="flexslider">
        <ul class="slides">
          <div
            class="lunBotu"
            :style="{ background: 'url(' + require('@/assets/images/introdution/gywm_banner.png') + ')'}"
          >
            <div class="container">
              <div class="ban2 float">
                <h2>让安全听得见，</h2>
                <h2>构建更加安全便利的世界！</h2>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>

    <!-- 公司简介 -->
    <introduction></introduction>

    <!-- 合作伙伴 -->
    <!-- <Partnership class="partnerShip"></Partnership>   -->
    <div
      style="height:300px;background:linear-gradient(88deg,rgba(58,30,90,1) 0%,rgba(31,12,52,1) 100%);"
    >
      <!-- 下载彩页 -->
      <div
        class="xccy"
        id="download"
        :style="{ background: 'url(' + require('@/assets/images/introdution/gongsi_banner.png') + ') no-repeat center center'}"
      >
        <div class="download">
          <el-tooltip class="item" effect="dark" content="为了更好地为您服务，请首先填写商务合作申请，谢谢" placement="top">
            <div class="gotodownload" @click="download">下载公司介绍</div>
          </el-tooltip>
          <!-- <div @click="download">下载</div> -->
        </div>
        <!-- <img src="@/assets/images/chanpin/xz_an.png" @click="download" /> -->
      </div>
    </div>

    <div class="positionBaidu">
      <!-- 公司地址 -->
      <div
        class="location"
        :style="{ background: 'url(' + require('@/assets/images/introdution/gywm.png') + ') no-repeat center center'}"
      >
        <div class="content-top">
          <div>
            <p>联系我们</p>
          </div>
          <div>
            <p>武汉总部</p>
          </div>
          <div>
            <p>中国•光谷•武大科技园航域二区B3栋7楼</p>
          </div>
          <div>
            <p>market@dasoundgen.com</p>
          </div>
          <div>
            <p>Tel:027—81736698</p>
          </div>
          <div @click="getBaiduMap">查看地图</div>
        </div>
        <div class="content-bottom clearfix">
          <div class="content-box" v-for="(item, index) in banshichu" :key="index">
            <div>{{item['name']}}</div>
            <div>
              <p v-for="(ite,ind) in item['attr']" :key="ind">{{ite}}</p>
            </div>
            <!-- <span>{{item['mail']}}</span> -->
            <span>{{item['call']}}</span>
          </div>
        </div>
      </div>
      <!-- 百度地图 -->
      <div class="baiduMap" v-if="mapFlag">
        <baidu-map
          :style="{width:map.width,height:map.height}"
          class="map"
          :center="{lng: map.lng, lat: map.lat}"
          :zoom="15"
          ak="VaqRvrmr4Ppo1iIAQsC5jiGjOBF73n40"
          @click="gotoDSJ"
        >
          <bm-marker :position="{lng: map.lng, lat: map.lat}" :dragging="true">
            <!-- <bm-label
              content="武汉大晟极科技有限公司"
              :offset="{width: -35, height: 30}"
            />-->
          </bm-marker>
        </baidu-map>
      </div>
      <div
        class="closeMap"
        @click="closeMAP"
        :style="{ background: 'url(' + require('@/assets/images/introdution/dt_gb.png') + ') no-repeat center center'}"
      ></div>
    </div>
  </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker'
import BmLabel from 'vue-baidu-map/components/overlays/Label'
import Partnership from '@/components/common/Partnership'
import introduction from '@/components/common/introduction'
// import { BaseURL } from '@/api/http.js'
export default {
  data () {
    return {
      map: {
        width: '1032px',
        height: '634px',
        lng: 114.412808,
        lat: 30.460901
      },
      banshichu: [
        { 'name': '北京办事处', 'attr': ['北京富海大厦1209室'], 'mail': 'market@dasoundgen.com', 'call': 'Tel:13810085777（汤经理）' },
        { 'name': '昆明办事处', 'attr': ['昆明市盘龙区北京路1178号', '鑫世界E幢2307室'], 'mail': 'market@dasoundgen.com', 'call': 'Tel:18987102426（唐经理）' },
        // { 'name': '荆门办事处', 'attr': ['荆门市东宝区象山大道53号'], 'mail': 'market@dasoundgen.com', 'call': 'Tel:13807263568（万经理）' }
      ],
      mapFlag: false
    }
  },
  methods: {
    // 打开地图
    getBaiduMap () {
      this.mapFlag = true
    },
    // 打开百度地图并搜索
    gotoDSJ () {
      const href = 'http://api.map.baidu.com/geocoder?address=武汉市东湖新技术开发区武大科技园兴业楼北楼一单元&output=html'
      window.open(href, '_blank')
    },
    // 下载宣传彩页
    download () {
      // const name = '彩页图'
      // const url = BaseURL + 'materials/downloadByName?typeName=' + name
      // window.open(url)
    },
    // 关闭地图
    closeMAP () {
      this.mapFlag = false
    }
  },
  components: {
    Partnership,
    BaiduMap,
    BmMarker,
    BmLabel,
    introduction
  }
}
</script>

<style scoped>
/* banner开始 */
.flexslider {
  position: relative;
  height: 584px;
  overflow: hidden;
  z-index: 1;
  clear: both;
  margin-top: -65px;
}
.lunBotu {
  margin-top: 4px;
  z-index: 1;
  background-size: 100% 100%;
  height: 587px;
}
.container .float {
  float: none;
  margin: 0 auto;
  width: 70%;
  margin-top: 75px;
}
.cpfa .ban2 h2 {
  text-align: center;
  margin-bottom: 46px;
}
/* banner结束 */

/* 简介开始 */
.intro {
  background-color: rgba(248, 248, 248, 1);
}
.intro > div:first-child {
  width: 980px;
  height: 584px;
}
h4 {
  font-size: 30px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  padding-top: 113px;
  padding-bottom: 40px;
}
.intro p {
  text-align: left;
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 26px;
}
.first {
  text-indent: 2em;
}
/* 简介结束*/

/* 合作伙伴 */
.partnerShip {
  margin-top: 105px;
  margin-bottom: 100px;
}
/* 下载彩页开始 */
.xccy {
  width: 100%;
  height: 300px;
  position: relative;
}
.download {
  width: 950px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -165px;
  margin-top: -124px;
}
.gotodownload {
  width: 335px;
  line-height: 85px;
  background: linear-gradient(
    86deg,
    rgba(116, 96, 238, 1) 0%,
    rgba(252, 72, 122, 1) 100%
  );
  border-radius: 4px;
  font-size: 36px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  filter: "progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=rgba(116, 96, 238, 1), endColorstr=rgba(252, 72, 122, 1))";
  -ms-filter: "progid:DXImageTransform.Microsoft.gradient (GradientType=1, startColorstr=#7460EE, endColorstr=#FC487A)";
}
/* 下载彩页结束 */
.positionBaidu {
  position: relative;
}
/* 公司地址开始 */
.location {
  margin-top: 87px;
  height: 729px;
  margin-bottom: 58px;
}
.content-top {
  width: 1000px;
  height: 440px;
  border-bottom: 1px solid rgba(208, 208, 208, 1);
}
.content-top p {
  position: relative;
  font-size: 22px;
  font-weight: 500;
  padding-bottom: 12px;
  color: #333333;
}
.content-top > div:first-child p {
  padding-top: 15px;
  padding-bottom: 65px;
  font-weight: bold;
  font-size: 30px;
}
.content-top > div:nth-child(2) p {
  padding-bottom: 51px;
  font-size: 28px;
  font-weight: bold;
}
.content-top > div:nth-child(3) p {
  padding-bottom: 21px;
  font-size: 27px;
  font-weight: bold;
}
.content-top > div:nth-child(4) p,
.content-top > div:nth-child(5) p {
  padding-bottom: 5px;
  font-size: 20px;
  font-weight: normal;
  color: rgba(102, 102, 102, 1);
}
.content-top > div:last-child {
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 52px;
  width: 160px;
  background: rgba(74, 17, 118, 1);
  border-radius: 4px;
  margin-top: 63px;
  box-shadow: -4px 26px 23px -21px rgba(74, 17, 118, 1);
}
/* 办事处 */
.content-bottom {
  width: 987px;
  justify-content: center;
    display: flex;
}
.content-box {
  width: 300px;
  height: 300px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  float: left;
  margin-top: 60px;
  margin-left: 26px;
}
.content-box > :first-child {
  width: 190px;
  line-height: 52px;
  background: rgba(226, 225, 227, 1);
  border-radius: 4px;
  font-size: 22px;
}
.content-box p {
  font-size: 21px;
  line-height: 28px;
}
.content-box > :nth-child(2) {
  margin-bottom: 30px;
  margin-top: 55px;
}
.content-bottom > :nth-child(2) > :nth-child(2) {
  margin-top: 45px;
  margin-bottom: 13px;
}
/* .content-bottom :nth-child(2) > p {
 margin-bottom: 1px
} */
.content-box span {
  font-size: 18px;
  font-weight: normal;
  color: rgba(102, 102, 102, 1);
}
/* 公司地址结束 */
.baiduMap {
  width: 100%;
  position: absolute;
  top: -86px;
  height: 1080px;
  background: rgba(0, 0, 0, 1);
  background: rgba(0, 0, 0, 0.5);
}
.map {
  margin-top: 70px;
}
.map /deep/ div:first-child {
  border-radius: 30px;
}
.closeMap {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  margin-left: 526px;
  margin-top: -347px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/aboutus/introdution/introduction.vue